import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  ListRoutingServicesRequest,
  ListRoutingServicesResponse,
  ListRoutingVehiclesRequest,
  ListRoutingVehiclesResponse,
  ProgramDeliveryRequest,
  UpdateMassiveDeliveryServiceResponse,
  UpdateVehicleOrderRequest,
} from '../../../../../shared/api/gen_api_client/routing_pb';
import * as grpcWeb from 'grpc-web';
import { MassiveDeliveryServiceClient } from '../../../../../shared/api/gen_api_client/RoutingServiceClientPb';
import { MdDetail, ObjectResponse, ObjectService, RoutedService, Vehicle, Zone, markesObject } from './services.interface';
import { MassiveService } from '../../../../massive.service';
import Marker = google.maps.Marker;
import LatLng = google.maps.LatLng;
import { GrpcFactoryService } from 'src/app/components/shared/sharedServices/grpc-factory.service';
import { environment } from 'src/environments/environment';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';
import { MassiveProgramFlags } from '../../massive-program.flags';
import { Request } from 'src/app/components/massive/models/request.interface';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';

/**
 * Import Interfaces
 */

/**
 * Import Services
 */

@Component({
  selector: 'app-servicios',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.sass'],
})
export class ServicesComponent extends MuComponent implements OnChanges {
  @Input() requestId: number;
  @Input() processingServices: ProcessingData<MassiveProgramFlags>;
  @Input() processingUpdateRouteOrder: ProcessingData<MassiveProgramFlags>;
  @Input() flags: Flags<MassiveProgramFlags>;
  @Output() returnValueFinal = new EventEmitter();

  stateExtras: {};
  activeServiceId: number;
  addressOptions: any;
  options: any;

  overlays: any[];
  overlaysEdit: any[];
  addressOverlays: any[];

  routedServices: RoutedService[];
  routedEditServices: RoutedService[];
  mdClient: MassiveDeliveryServiceClient;

  selectedMdReq: Request;
  vehicles: Vehicle[] = null;
  vehiclesExport: Vehicle[] = null;
  itemExport: ObjectService = null;
  objectExport: ObjectService[] = [];

  map: google.maps.Map;
  mapEdit: google.maps.Map;
  addressMap: google.maps.Map;

  mdRequestDetails: MdDetail[] = null;

  userId: number;
  zone: string;
  subZone: string;
  description: string;
  serviceProgramVisible: any = false;
  mdloadingmasivo: boolean;
  mdloadingerrormasivo: boolean;
  reponseStateMassivo: string;
  reponseMsgMassivo: string;
  itemVehicleSelected: number;
  selectedVehicle: Vehicle;
  typeVehicleIdSelected: number;
  mdloadingerrorMasivoMsn: boolean;
  editNumberPoint: boolean;
  titleHeader: string;
  showLoadingUpdateData: boolean;
  showMapRoute: boolean;
  showMapRouteEdit: boolean;
  markesMapMu: markesObject[];
  boundsMap = new google.maps.LatLngBounds();

  loading = false;

  zones: Zone[] = [];
  selectedZone: Zone = null;

  constructor(private massiveService: MassiveService, private grpcFactoryService: GrpcFactoryService, private router: Router) {
    super();
    this.stateExtras = this.router.getCurrentNavigation()?.extras?.state;
    this.activeServiceId = 0;
    this.mdloadingmasivo = false;
    this.mdloadingerrormasivo = false;
    this.reponseStateMassivo = '';
    this.reponseMsgMassivo = '';
    this.mdloadingerrorMasivoMsn = false;
    this.editNumberPoint = false;
    this.showLoadingUpdateData = false;
    this.itemVehicleSelected = 0;
    this.showMapRoute = true;
    this.showMapRouteEdit = false;
    this.markesMapMu = [];
    this.mdClient = this.grpcFactoryService.create(
      MassiveDeliveryServiceClient,
      environment.hostnameMassive,
      'MassiveDeliveryServiceClient'
    );
  }

  muOnInit() {
    this.options = {
      center: { lat: 4, lng: 72 },
      zoom: 12,
    };

    this.addressOptions = {
      center: { lat: 4, lng: 72 },
      zoom: 12,
    };
    this.typeVehicleIdSelected = this.massiveService.getTypeVehicleSelected()?.id || 0;
    this.watch(this.flags.valueChanges(MassiveProgramFlags.UPDATE_ROUTE_ORDER_FAIL)).subscribe(value => {
      if (value.value === false) {
        this.editNumberPoint = true;
      }
    });
  }

  muOnDestroy() {
    /** */
  }

  ngOnChanges(changes: SimpleChanges) {
// eslint-disable-next-line no-prototype-builtins
    if (changes.hasOwnProperty('requestId')) {
      this.activeServiceId = changes.requestId.currentValue;
    }
    if (this.activeServiceId > 1) {
      this.loadServiceVehicles();
    } else {
      this.mdloadingerrormasivo = true;
      if (this.activeServiceId === 0) {
        setTimeout(() => {
          this.mdloadingerrorMasivoMsn = true;
        }, 3000);
      }
    }
  }

  async loadServiceVehicles() {
    this.mdloadingmasivo = false;
    this.mdloadingerrormasivo = true;
    this.selectedMdReq = await this.massiveService.getMassiveDeliveryService(this.activeServiceId);
    this.refreshVehicles();
    this.routedServices = [];
    this.routedEditServices = [];
  }

  refreshVehicles(move: boolean = false) {
    const request = new ListRoutingVehiclesRequest();
    request.setRequestid(this.activeServiceId);
    this.mdClient.listRoutingVehicles(request, {}, (err: grpcWeb.Error, response: ListRoutingVehiclesResponse) => {
      if (response) {
        this.vehicles = response.getVehiclesList().map(vehicle => {
          return {
            vehicleId: vehicle.getVehicleid(),
            routingId: vehicle.getRoutingid(),
            plate: vehicle.getPlate(),
            capacity: vehicle.getCapacity(),
            usedCapacity: vehicle.getUsedcapacity(),
            type: vehicle.getType(),
            apiServiceMessage: vehicle.getApiservicemessage(),
            apiServiceId: vehicle.getApiserviceid(),
          };
        });
        if (this.vehicles.length > 0) {
          this.mdloadingerrormasivo = false;
        } else {
          this.mdloadingerrorMasivoMsn = true;
        }
      } else {
        this.mdloadingerrorMasivoMsn = true;
      }
    });
  }

  refreshVehicleServices(vehicle: Vehicle) {
    this.selectedVehicle = vehicle;
    const vehicleId = vehicle.vehicleId;
    this.titleHeader = `Editar Servicios Ruta ${vehicleId}`;
    this.itemVehicleSelected = vehicleId;
    const request = new ListRoutingServicesRequest();
    request.setVehicleid(vehicleId);
    this.mdClient.listRoutingServices(request, {}, (err: grpcWeb.Error, response: ListRoutingServicesResponse) => {
      if (err) {
        console.log(err);
      } else {
        this.routedServices = [];
        let count = 0;
        this.routedServices = response.getDetailsList().map(service => {
          return {
            requestId: service.getRequestid(),
            serviceId: service.getServiceid(),
            clientId: service.getClientid(),
            clientName: service.getClientname(),
            address: service.getAddress(),
            orderId: service.getOrderid(),
            weight: service.getWeight(),
            phone: service.getPhone(),
            status: service.getStatus(),
            lat: service.getLat(),
            lng: service.getLng(),
            order: ++count,
            edit: false,
          };
        });
        this.routedEditServices = [];
        this.routedEditServices = this.routedServices.map(service => {
          return service;
        });
      }

      this.overlays = this.drawMarketsinMap(this.map, this.routedServices);
      this.map.fitBounds(this.boundsMap);
    });
  }

  showServiceCreation() {
    this.serviceProgramVisible = true;
  }

  setMap(event) {
    this.map = event.map;
    this.map.fitBounds(this.boundsMap);
  }

  setMapEdit(event) {
    this.mapEdit = event.map;
    this.mapEdit.fitBounds(this.boundsMap);
  }

  async exportExcel() {
    this.vehiclesExport = this.vehicles;
    const arrayvehicles = this.vehiclesExport.map(item => {
      return {
        uuidItem: item.apiServiceId,
        statusItem: item.apiServiceMessage,
      };
    });
    this.objectExport = [];
    this.getData().then(data => {
      data.forEach((service, skey) => {
        Object.keys(service).forEach((key, index) => {
          this.itemExport = {
            idItem: +key + +1,
            datefil: this.selectedMdReq.startDate,
            idCliente: service[key].clientid,
            cliente: service[key].clientname,
            address: service[key].address,
            orderId: service[key].orderid,
            weight: service[key].weight,
            phone: service[key].phone,
            muGuide: service[key].serviceid,
            minHour: this.selectedMdReq.startTime,
            maxHour: this.selectedMdReq.endTime,
            route: `Ruta ${service[key].route}`,
// eslint-disable-next-line @typescript-eslint/dot-notation
            // eslint-disable-next-line @typescript-eslint/dot-notation
            uuid: arrayvehicles[skey].uuidItem ? arrayvehicles[skey].uuidItem : 'NO PROGRAMADO',
// eslint-disable-next-line @typescript-eslint/dot-notation
            // eslint-disable-next-line @typescript-eslint/dot-notation
            status: arrayvehicles[skey]['statusItem'] ? arrayvehicles[skey]['statusItem'] : 'SIN ESTADO',
            storeId: service[key].storeid,
            idPointClient: service[key].idclientpoint,
            idPoint: service[key].clientpointname,
          };
          this.objectExport.push(this.itemExport);
        });
      });
      import('xlsx').then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.objectExport);
// eslint-disable-next-line @typescript-eslint/naming-convention
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        this.saveAsExcelFile(excelBuffer, 'MassivosTable');
      });
    });
  }

  /**
   * Generate excel file and download it
   *
   * @param buffer
   * @param fileName
   */
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  vehiclesString() {
    const vehiclesExport = [];
    for (const itemVehicle of this.objectExport) {
      vehiclesExport.push(itemVehicle);
    }
    return vehiclesExport;
  }

  getData = async () => {
    return Promise.all(
      this.vehiclesExport.map(async (item, key) => {
        const response: ObjectResponse = await this.refreshVehicleServicesExport(item);
        return response.detailsList;
      })
    );
  };

  refreshVehicleServicesExport = vehicleObject => {
    return new Promise((resolve, reject) => {
      const request = new ListRoutingServicesRequest();
      request.setVehicleid(vehicleObject.vehicleId);
      this.mdClient.listRoutingServices(request, {}, (err: grpcWeb.Error, response: ListRoutingServicesResponse) => {
        if (err) {
          return reject(err);
        }
        const responseData = response.toObject();
        resolve(responseData);
      });
    });
  };

  /**
   * Build streaming with a request
   */
  buildStreaming(): any {
    this.serviceProgramVisible = false;
    this.reponseStateMassivo = '';
    this.reponseMsgMassivo = '';
    const request = new ProgramDeliveryRequest();
    const idSel = this.selectedMdReq.requestId;
    request.setRequestid(idSel);
    request.setUserid(this.userId);
    if (this.selectedZone != null) {
      request.setZone(this.selectedZone.zoneId);
    }
    request.setSubzone(this.subZone);
    request.setDescription(this.description);
    request.setVehicleid(this.itemVehicleSelected);
    request.setVehicletypeid(this.typeVehicleIdSelected);
    return this.mdClient.programDelivery(request, {});
  }

  programDelivery() {
    this.processingServices.begin();
    const streaming = this.buildStreaming();
    if (!streaming || typeof streaming.on !== 'function') {
      return environment.guardClause;
    }
    streaming.on('data', data => {
      if (data.getStatus() === 'TICK') {
        return environment.guardClause;
      }
      if (data.getStatus() === 'END') {
        this.reponseStateMassivo = data.getStatus();
        this.reponseMsgMassivo = data.getMessage();
        this.refreshVehicles(true);
        this.mdloadingmasivo = true;
        this.processingServices.end();
        return environment.guardClause;
      }
      if (data.getStatus() !== 'OK') {
        const msg = data.getMessage();
        this.refreshVehicles(true);
        this.processingServices.markError(msg);
        return environment.guardClause;
      }
      this.processingServices.init(data.getRecordsquantity());
      this.processingServices.setProgress(data.getRecordsprocessed());
    });
    streaming.on('error', err => {
      this.processingServices.markError('context.massive.creatingServices.genericErrorMessage');
    });
  }

  returnTwoStep() {
    this.mdloadingerrormasivo = false;
    this.mdloadingerrorMasivoMsn = false;
    this.returnValueFinal.emit(1);
  }

  returnInitialStep() {
    this.mdloadingmasivo = false;
    this.refreshVehicles(true);
  }

  showEditPoint() {
    this.showMapRouteEdit = true;

    this.editNumberPoint = !this.editNumberPoint;

    this.overlaysEdit = this.drawMarketsinMap(this.mapEdit, this.routedServices);
    if (this.mapEdit) {
      this.mapEdit.fitBounds(this.boundsMap);
      this.mapEdit.setZoom(13);
    }
  }

  hideEditPoint() {
    this.showMapRoute = true;
    this.editNumberPoint = false;
  }

  /**
   * reorder stops and refresh map
   *
   * @param event
   */
  onReorder(event): void {
    this.routedEditServices = this.mapRoutedEditServices(this.routedEditServices);
    this.overlaysEdit = this.drawMarketsinMap(this.mapEdit, this.routedEditServices);
    this.mapEdit.fitBounds(this.boundsMap);
  }

  zoomTo(service: RoutedService) {
    this.map.setZoom(15);
    this.map.panTo(
      new LatLng({
        lat: Number(service.lat),
        lng: Number(service.lng),
      })
    );
    this.getZoomItem(service);
  }

  zoomToEdit(service: RoutedService) {
    this.mapEdit.setZoom(15);
    this.mapEdit.panTo(
      new LatLng({
        lat: Number(service.lat),
        lng: Number(service.lng),
      })
    );
    this.getZoomItem(service);
  }

  getZoomItem(service: RoutedService): any {
    this.routedServices = this.routedServices.map((item, index) => {
      if (item.serviceId === service.serviceId) {
        item.edit = true;
      } else {
        item.edit = false;
      }
      return item;
    });
  }

  drawMarketsinMap(objMap, objectDraw) {
    const image = {
      url: '../../../../../../../assets/images/service/map/ic-pin-recogida.png',
      size: new google.maps.Size(27, 36),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 36),
    };
    if (!objectDraw) return environment.guardClause;
    const overlaysObject = objectDraw.map(service => {
      return new Marker({
        position: {
          lat: Number(service.lat),
          lng: Number(service.lng),
        },
        title: service.clientName,
        label: service.order.toString(),
        icon: image,
      });
    });
    const cedi = new Marker({
      position: {
        lat: Number(this.selectedMdReq.lat),
        lng: Number(this.selectedMdReq.lng),
      },
      title: 'Centro de Distribucion',
      label: 'CEDI',
      icon: image,
    });
    overlaysObject.unshift(cedi);
    overlaysObject.push(cedi);
    const paths: Array<LatLng> = overlaysObject.map((ov: Marker) => {
      return ov.getPosition();
    });

    this.boundsMap = new google.maps.LatLngBounds();
    overlaysObject.forEach(marker => {
      this.boundsMap.extend(marker.getPosition());
    });

    overlaysObject.push(
      new google.maps.Polyline({
        path: paths,
        geodesic: true,
        strokeColor: '#000000',
        strokeOpacity: 0.5,
        strokeWeight: 2,
        icons: overlaysObject.map(a => {
          return {
            icon: {
              path: google?.maps?.SymbolPath?.FORWARD_CLOSED_ARROW,
            },
            repeat: '50px',
          };
        }),
      })
    );
    return overlaysObject;
  }

  updatePoints(service: RoutedService) {
    let idKeyOld = 0;
    this.routedEditServices.forEach((item, index) => {
      if (item.serviceId === service.serviceId) {
        idKeyOld = index;
      }
    });
    this.routedEditServices = this.mapRoutedEditServices(this.reOrderData(this.routedEditServices, idKeyOld, service.order - 1));
    this.overlaysEdit = this.drawMarketsinMap(this.mapEdit, this.routedEditServices);
    if (this.mapEdit) {
      this.mapEdit.fitBounds(this.boundsMap);
    }
  }

  mapRoutedEditServices(listOrder): any {
    return listOrder.map((item, index) => {
      item.order = index + 1;
      item.edit = false;
      return item;
    });
  }

  reOrderData(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  saveDataRoute() {
    this.processingUpdateRouteOrder.begin();
    this.editNumberPoint = false;
    this.showLoadingUpdateData = true;
    const request = new UpdateVehicleOrderRequest();
    request.setVehicleid(this.selectedVehicle.vehicleId);
    request.setRoutingid(this.selectedVehicle.routingId);
    request.setServiceidList(
      this.routedEditServices.map(addressItem => {
        return +addressItem.serviceId;
      })
    );
    this.mdClient.updateVehicleOrder(request, {}, (err: grpcWeb.Error, response: UpdateMassiveDeliveryServiceResponse) => {
      if (err) {
        this.editNumberPoint = true;
        this.processingUpdateRouteOrder.markError(err.message);
        return environment.guardClause;
      }
      if (response.getStatus() !== 'OK') {
        this.processingUpdateRouteOrder.markError(response.getStatus());
        return environment.guardClause;
      }
      this.showLoadingUpdateData = false;
      this.showMapRoute = true;
      this.refreshVehicleServices(this.selectedVehicle);
      this.processingUpdateRouteOrder.end();
    });
  }

  goBack() {
    this.router.navigate(['/masivos/deliveries/'], {state: this.stateExtras});
  }
}
